import { faClock } from '@fortawesome/free-solid-svg-icons'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { Colors } from '../../../../utils/colors/colors'
import { NotificationProps } from '../../FactoryNotification/FactoryNotification'
import GenericNotification from '../GenericNotification'


interface ExpiredOfferNotificationProps extends NotificationProps {
	item: {
		id: string,
		notifMsg: string,
		timestamp: number,
		viewed: boolean,
		notifData: {
			receivedFromType: string,
			nameOffer: string,
			type: string
		},
	}
}


const ExpiredOfferNotification = ({ item, clickable, onSetNotificationAsView }: ExpiredOfferNotificationProps) => {
	const { id, notifMsg, timestamp, viewed, notifData: { nameOffer, type } } = item
	const { t } = useTranslation()
	const touchNotification = useCallback(
		() => {
			if (!viewed)
				onSetNotificationAsView(id)
		},
		[],
	)

	return (
		<GenericNotification
			touchNotification={touchNotification}

			id={id}
			timestamp={timestamp}
			viewed={clickable ? viewed : true}
			description={t("Notifications:index:label_33")}
			title={`${t("Notifications:index:label_34")} ${t(`Jobs:${nameOffer.replace(/\s/g, "")}`)} ${t("Notifications:index:label_35")}`}
			icon={faClock}
			color={type === "Gimmer" ? Colors.secondaryColor : Colors.mainColor}
		/>
	)
}

export default React.memo(ExpiredOfferNotification)